import { render, staticRenderFns } from "./consignmentReturnReportList.vue?vue&type=template&id=dafe3e84"
import script from "./consignmentReturnReportList.vue?vue&type=script&lang=js"
export * from "./consignmentReturnReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports